import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
    return (
        <div className="d-flex align-items-center justify-content-center vh-100 bg-primary">
            <div className="text-center">
                <h1 className="display-1 fw-bold text-white">404</h1>
                <Link className="btn btn-dark rounded-pill px-5 fs-6 m-0" to="/" role="button">Back to Home</Link>
            </div>
        </div>
    )
}

export default NotFound;
